module.exports = __webpack_public_path__ + "static/media/(000131).d2d26688.jpg";